import React from "react";
import "./Background.css";

export default function Background() {
    return (
        <div>
            <div className="eclipse min"></div>
            <div className="eclipse small"></div>
            <div className="eclipse middle"></div>
            <div className="eclipse large"></div>
        </div>
    );
}
